import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import {
  computeHouseAvailabilitiesIndividualToInputDto,
  computeHouseAvailabilityIndividualToInputDto,
} from '../../helpers/compute-house-availability-individual'
import {
  HouseAvailabilityGlobalOrIndividualDto,
  HouseAvailabilityGlobalOrIndividualManyDto,
} from '../../../../../../../lib/graphql'
import { Button } from '../../../../../../../shadcn/components/ui/button'
import { Spinner } from '../../../../../../atoms'
import {
  BigCalendarModalIndividualFormProps,
  useBigCalencarFormContext,
} from '../../../shared/calendar/utils/use-big-calendar-form'

export type BigCalendarModalFooterIndividualProps = {
  onUpsertHouseAvailability: {
    isLoading: boolean
    mutate: (inputDto: HouseAvailabilityGlobalOrIndividualDto) => void
  }
  onUpsertManyHouseAvailabilities: {
    isLoading: boolean
    mutate: (inputDto: HouseAvailabilityGlobalOrIndividualManyDto) => void
  }
  isFormDisabled: boolean
}
export const BigCalendarModalFooterIndividual = ({
  onUpsertHouseAvailability: { isLoading, mutate },
  onUpsertManyHouseAvailabilities: {
    isLoading: isLoadingMany,
    mutate: mutateMany,
  },
  isFormDisabled,
}: BigCalendarModalFooterIndividualProps) => {
  const { handleOnModalClose, modalFormProps: modalState } =
    useBigCalencarFormContext()

  if (!modalState?.formValues) {
    return (
      <div className='flex w-full justify-end gap-4'>
        <Button
          onClick={handleOnModalClose}
          disabled={isLoading}
          className='min-w-[120px]'
        >
          <FormattedMessage
            id='ui.BigCalendarModalFooterIndividual.cancel'
            defaultMessage='Annuler'
          />
        </Button>
      </div>
    )
  }

  const handleOnClose = (formData?: BigCalendarModalIndividualFormProps) => {
    reset(formData)

    handleOnModalClose()
  }

  const {
    handleSubmit,
    formState: { isValid, isDirty },
    reset,
  } = useFormContext<BigCalendarModalIndividualFormProps>()

  const onSubmitCell = (formData: BigCalendarModalIndividualFormProps) => {
    const inputDto = computeHouseAvailabilityIndividualToInputDto(formData)

    mutate(inputDto)

    handleOnClose(formData)
  }

  const onSubmitSlots = (formData: BigCalendarModalIndividualFormProps) => {
    if (formData.type !== 'slots') {
      return
    }

    const inputDto = computeHouseAvailabilitiesIndividualToInputDto(formData)

    mutateMany(inputDto)

    handleOnClose(formData)
  }

  const onSubmit = (formData: BigCalendarModalIndividualFormProps) => {
    const { type } = modalState

    if (type === 'cell') {
      return onSubmitCell(formData)
    }

    if (type === 'slots') {
      return onSubmitSlots(formData)
    }
  }

  return (
    <div className='flex w-full justify-end gap-4'>
      <Button
        onClick={() => handleOnClose()}
        disabled={isLoading || isLoadingMany || isFormDisabled}
        className='min-w-[120px]'
      >
        <FormattedMessage
          id='ui.BigCalendarModalFooterIndividual.cancel'
          defaultMessage='Annuler'
        />
      </Button>

      <Button
        type='submit'
        onClick={handleSubmit(onSubmit)}
        disabled={
          !isValid || !isDirty || isLoading || isLoadingMany || isFormDisabled
        }
        className='min-w-[120px]'
      >
        {isLoading ? (
          <Spinner height={20} width={20} />
        ) : (
          <FormattedMessage
            id='ui.BigCalendarModalFooterIndividual.save'
            defaultMessage='Enregistrer'
          />
        )}
      </Button>
    </div>
  )
}
